import dayjs from 'dayjs';

import {
  AVIA_TOUR_PROMO_DURATION_DAYS,
  AVIA_TOUR_PROMO_START_DATE,
} from './config';

const promoStartDate = dayjs(AVIA_TOUR_PROMO_START_DATE);

const promoEndDate = promoStartDate.add(AVIA_TOUR_PROMO_DURATION_DAYS, 'day');

export const getAviaTourPromoDaysLeft = (now?: dayjs.ConfigType): number =>
  Math.ceil(promoEndDate.diff(dayjs(now), 'day', true));

export const isAviaTourPromoWithinWindow = (
  now?: dayjs.ConfigType,
): boolean => {
  const currentDate = dayjs(now);

  return (
    !currentDate.isBefore(promoStartDate) && currentDate.isBefore(promoEndDate)
  );
};
